import React from 'react';

import { useIntl } from 'react-intl';

import { useCreateSite } from 'src/features/sites/api/useCreateSite';
import { LIST_SITES_RESOURCE } from 'src/features/sites/api/useListSites';
import SiteFormModal from 'src/features/sites/components/SiteFormModal';
import { Site } from 'src/features/sites/utils/types';
import { siteMessages } from 'src/features/sites/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { useParking } from 'src/providers/ParkingProvider';
import { ICON_MAP } from 'src/utils/constants';

interface SiteFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedSite?: Site;
    children?: React.ReactNode;
}

function CreateSiteFormModal<TData>({ className, semantics }: SiteFormModalProps<TData>) {
    const { formatMessage, locale } = useIntl();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateSite({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SITES_RESOURCE] });
            toast({
                title: formatMessage(siteMessages.createSiteSuccess),
                description: formatMessage(siteMessages.createSiteSuccessDescription, {
                    entry: success.translations.find((translation) => translation.language === locale)?.language,
                }),
            });
        },
    });

    return (
        <SiteFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ parkingId: parkingId, ...values}, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(siteMessages.addSiteSubtitle)}
        />
    );
}

export default CreateSiteFormModal;
